

import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import { convertTimestampToDate } from "../../../utils/helpers";

const ViewStatus = ({ open, onClose, candidate_statusinfo }) => {
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "interested":
        return "primary";
      case "active":
        return "info";
      case "hired":
        return "success";
      case "inactive":
        return "error";
      case "rejected":
        return "error";
      case "offer extended":
        return "warning";
      case "blocked":
        return "error";
      case "engaged":
        return "primary";
      case "interview":  // New case added for interview
        return "secondary";  // Specify your desired color here
      default:
        return "default";
    }
  };
  

  const formatDate = (date) => {
    return format(new Date(date), "MM/dd/yyyy");
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose();
        }
      }}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "17px",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle sx={{ padding: 0 }}>
        <Box
          sx={{
            backgroundColor: "#250258",
            padding: "12px 16px",
            position: "relative",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "white", fontWeight: "bold", fontSize: "18px" }}
          >
            Stages
          </Typography>
          <IconButton
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "white",
            }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          margin: "15px",
        }}
      >
        {/* <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            {candidate_statusinfo && candidate_statusinfo.length > 0 ? (
              candidate_statusinfo.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      border: "1px solid #e0e0e0",
                      borderRadius: "12px",
                      backgroundColor: "#f5f5f5",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "transform 0.2s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.03)",
                      },
                      minHeight: "5rem",
                      p: 2, 
                    }}
                  >
                   
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "600",
                          fontSize: "12px",
                          color: "black",
                          mx: 0.5,
                        }}
                      >
                        Process Date:-
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "400", fontSize: "13px" }}
                      >
                        {formatDate(item.cdate.$date)}
                      </Typography>
                    </Box>

                   
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignContent: "center",
                        alignItems: "center",
                      }}
                    >
                     
                      <Chip
                        label={item.status}
                        color={getStatusColor(item.status)}
                        sx={{
                          fontSize: "11px",
                          textTransform: "capitalize",
                          fontFamily: "Urbane-light",
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          padding: "0 5px",
                          width: "fit-content",
                          alignSelf: "center",
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              ))
            ) : (
              <Grid
                item
                xs={12}
                container
                justifyContent="center"
                alignItems="center"
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "17px",
                    lineHeight: "40px",
                    textAlign: "center",
                  }}
                >
                  No Status Available!
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box> */}

<Box sx={{ mt: 2 }}>
  <Table sx={{ width: "100%", borderCollapse: "collapse" }}>
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            padding: "8px",
            fontWeight: "bold",
            textAlign: "left",
            borderBottom: "2px solid #ddd",
            color: "#333",
            fontSize: "14px",
            boxSizing: "border-box", // Ensure box-sizing for consistent width
          }}
        >
          Process Date
        </TableCell>
        <TableCell
          sx={{
            padding: "8px",
            fontWeight: "bold",
            textAlign: "left",
            borderBottom: "2px solid #ddd",
            color: "#333",
            fontSize: "14px",
            boxSizing: "border-box", // Ensure box-sizing for consistent width
          }}
        >
         	Stages
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {candidate_statusinfo && candidate_statusinfo.length > 0 ? (
        candidate_statusinfo.map((item, index) => (
          <TableRow key={index}>
            <TableCell
              sx={{
                padding: "8px",
                borderBottom: "1px solid #ddd",
                color: "#555",
                fontSize: "14px",
                boxSizing: "border-box", // Consistent box-sizing
              }}
            >
              {convertTimestampToDate(item.cdate.$date)}
            </TableCell>
            <TableCell
              sx={{
                
                padding: "8px",
                borderBottom: "1px solid #ddd",
                
                alignItems: "center",
                gap: "8px",
                boxSizing: "border-box", // Consistent box-sizing
              }}
            >
              {/* Bullet Point */}
              <Box sx={{ display: "flex", alignItems: "center", }}>
              <Box
                sx={{
                  mx: "5px",
                  width: "9px",
                  height: "9px",
                  borderRadius: "50%",
                  backgroundColor: (theme) =>
                    theme.palette[getStatusColor(item.status)]
                      ? theme.palette[getStatusColor(item.status)].light
                      : "#ccc", // Use light variant of the color
                }}
              ></Box>
              {/* Status Text */}
              <Typography
                sx={{
                  
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  fontSize: "14px",
                  color: (theme) =>
                    theme.palette[getStatusColor(item.status)]
                      ? theme.palette[getStatusColor(item.status)].light
                      : "#555", // Use light variant of the color
                }}
              >
                {item.status.toUpperCase()}
              </Typography>
              </Box>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell
            colSpan={2}
            sx={{
              textAlign: "center",
              padding: "12px",
              fontSize: "14px",
              color: "#555",
              boxSizing: "border-box", // Ensure box-sizing consistency
            }}
          >
            No Status Available!
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</Box>
      </DialogContent>
    </Dialog>
  );
};

export default ViewStatus;
